import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"

const IndexPage = () => {
  return (

    <html lang="en-US">
      <head>

          <meta http-equiv="refresh" content="0; url=https://www.forexanalytix.com/webinars" />
            <script type="text/javascript">
           {typeof window !== "undefined" ? window.location.href = "https://www.forexanalytix.com/webinars" : null}
            </script>
            <title>Page Redirection</title>

          </head>
          <body>
            If you are not redirected automatically, follow this <a href='https://www.forexanalytix.com/webinars'>link to example</a>.
          </body>
      </html>
  )

  {/* return (
    <Layout>
      <Seo title='FACE'/>
    </Layout>
  ) */}
}

export default IndexPage
